<template>
    <transition name="modal">
        <div class="modal" ref="modal">
            <div class="modal--wrapper">
                <div class="modal--container">
                    <span class="close" @click="$emit('close');">⒳</span>
                    <slot></slot>
                </div>
                <div class="modal--bg"></div>
            </div>
        </div>
    </transition>
</template>

<script>
// import '@/assets/svg/close.svg?sprite';

export default {
    name: 'modal',
}
</script>

<style lang="scss">
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9998;
        transition: opacity .3s ease;

        &--wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            overflow: auto;
            align-items: center;
            box-sizing: border-box;
            padding: var(--padding);
        }

        &--container {
            position: relative;
            z-index: 9;
            background: var(--green);
            color: white;
            margin: auto;
            overflow: hidden;
            max-width: 90rem;
            width: auto;
            transition: all .3s ease;
            padding: var(--padding-x3);
        }

        &--bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(#000, .5);
        }

        .close {
            position: absolute;
            z-index: 9;
            right: 1rem;
            top: 1rem;
            width: 2rem;
            height: 2rem;
            cursor: pointer;
            
            svg {
                height: 100%;
                width: 100%;
                fill: none;
                stroke: white;
                stroke-miterlimit: 10;
                stroke-width: 1px;
            }

        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal--container,
    .modal-leave-active .modal--container {
        transform: scale(1.1);
    }
</style>
